export default __webpack_public_path__ + "static/media/favicon.dd9f54c7.ico";